export namespace IFindDriver {
  export enum Action {
    FindDriver = 'FindDriver',
  }

  export interface ITableEntity {
    phone: string;
    persName: string;
    mainPhoneFlag: boolean;
  }
}